import { defineMessages } from "react-intl";

const messages = defineMessages({
  columnDateTime: {
    id: "Appointment.AppointmentsPreviewGrid.columnDateTime",
    defaultMessage: "Date/Time",
  },
  columnCenter: {
    id: "Appointment.AppointmentsPreviewGrid.columnCenter",
    defaultMessage: "Location",
  },
  columnStatus: {
    id: "Appointment.AppointmentsPreviewGrid.columnStatus",
    defaultMessage: "Status",
  },
  columnCenterServices: {
    id: "Appointment.AppointmentsPreviewGrid.columnCenterServices",
    defaultMessage: "Offering",
  },
  btnView: {
    id: "Appointment.AppointmentsPreviewGrid.btnView",
    defaultMessage: "View",
  },
  statusCheckout: {
    id: "Appointment.AppointmentsPreviewGrid.statusCheckout",
    defaultMessage: "Checkout",
  },
  statusIncomplete: {
    id: "Appointment.AppointmentsPreviewGrid.statusIncomplete",
    defaultMessage: "Incomplete",
  },
  statusAbandoned: {
    id: "Appointment.AppointmentsPreviewGrid.statusAbandoned",
    defaultMessage: "Abandoned",
  },
  statusConfirmed: {
    id: "Appointment.AppointmentsPreviewGrid.statusConfirmed",
    defaultMessage: "Confirmed",
  },
  statusCanceled: {
    id: "Appointment.AppointmentsPreviewGrid.statusCanceled",
    defaultMessage: "Canceled",
  },
  statusStudiesUnread: {
    id: "Appointment.AppointmentsPreviewGrid.statusStudiesUnread",
    defaultMessage: "Studies unread",
  },
  statusStudiesRead: {
    id: "Appointment.AppointmentsPreviewGrid.statusStudiesRead",
    defaultMessage: "Studies read",
  },
  statusReportsSent: {
    id: "Appointment.AppointmentsPreviewGrid.statusReportsSent",
    defaultMessage: "Reports sent",
  },
  statusReportsError: {
    id: "Appointment.AppointmentsPreviewGrid.statusReportsError",
    defaultMessage: "Reports error",
  },
  statusCheckedIn: {
    id: "Appointment.AppointmentsPreviewGrid.statusCheckedIn",
    defaultMessage: "Checked in",
  },
  statusIntakeComplete: {
    id: "Appointment.AppointmentsPreviewGrid.statusIntakeComplete",
    defaultMessage: "Intake complete",
  },
  statusNoShow: {
    id: "Appointment.AppointmentsPreviewGrid.statusNoShow",
    defaultMessage: "No show",
  },
});

export default messages;
